import { render, staticRenderFns } from "./ViTeacherAcademicManagementGradeSetting.vue?vue&type=template&id=0ab91c92"
import script from "./ViTeacherAcademicManagementGradeSetting.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementGradeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports